// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:09:53+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            1f9fbfb00e90d309115198100029eb74
//    Signature:      eyJpdiI6ImNOUVBtYm9BbXArNUpZZjlMeDBoUUE9PSIsInZhbHVlIjoidHVmSmxNZm5TUVdkSEtTTFRSSmpLZGM4aGlaWTY5NG9FeEt2bjdnVHROOE13eDVrWU1JcnhXNnhVY1VtR1F4OWZPOVdcL3M3TnhISGI0NVQydEI1RGNQdUVmNWxMOFdZelpWYmN5VW5hSGRNaDkyYzd4NDVuY1FJV3lnYnB6OFVoOXBxOGZtVVptNDdUa1NQckh6Q1IwekhKaFwvdzZGNUNsRyt6TEtTeVMzMjFhSlwvTllHdFFxcG1XRkJKT2xKSythTXpIejFyTFFObHgrUnhKRDhVNFU4dDhxQU04bmlnNTJVZUhTczlVN1hCWWZscjdYSFwvNVwvR05VbkIwRVdHU09la0s0OTNYSU1yUUpqeVAwbFh6V2hnRmU0Q0pcL1htNjN4STR2cFJTNVFEcjF3cTFkQnB5Rzl3RkdIQlBOZUVpN3RHdlFYTlhBditUXC96Q1JBWXJiY2d2WFhINmZaN0ZocnZFaFRFclcyTWFKTWhxNDZTbEZpWXl1bHRrWGppYUlwYkRhcXFJV1pxWFpsb0JaZ0ZVeG5BY2c9PSIsIm1hYyI6IjE3NTE0MzdjZjk0ZDJiMjM3YzkyNTBiMzBkYjQ4ODAxMTJmNTI4NDRiMDAwYzc0NTYxZWM2MzI5M2I1M2ZmNWQifQ==
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
